import { flow, Instance, SnapshotIn, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { Municipality } from './models/Municipality';
import { getEnvironment } from './utils';

export const MunicipalityStore = types
  .compose(
    getBaseStore<Instance<typeof Municipality>, SnapshotIn<typeof Municipality>>(
      Municipality,
      'municipalityId',
      'municipality',
    ),
    types.model('MunicipalityStore', {}),
  )
  .actions((self) => {
    const env = getEnvironment(self);
    const apiFetcher = env.api;

    const saveMunicipality = flow(function*(municipality: Instance<typeof Municipality>) {
      const res = yield self.saveElement(municipality);
    });

    const createMunicipality = flow(function*(municipality: Instance<typeof Municipality>) {
      const res = yield self.createElement(municipality);
    });

    const uploadMunicipalityFile = flow(function*(data: File) {
      const dt = new FormData();
      dt.append('file', data, data.name);
      const settings = { headers: { 'Content-Type': undefined } };
      const res = yield env.api.putFile('Municipality/upload/municipalities', dt, settings);
      return res;
    });

    const uploadPostalCodesFile = flow(function*(data: File, source: string = 'statbel') {
      const dt = new FormData();
      dt.append('file', data, data.name);
      const settings = { headers: { 'Content-Type': undefined } };
      const res = yield env.api.putFile(`Municipality/upload/postal-codes/${source}`, dt, settings);
      return res;
    });

    const uploadPopulationFile = flow(function*(data: File) {
      const dt = new FormData();
      dt.append('file', data, data.name);
      const settings = { headers: { 'Content-Type': undefined } };
      const res = yield env.api.putFile('Municipality/upload/population', dt, settings);
      return res;
    });

    const getNeighbors = flow(function*(municipalityId: number) {
      const result = yield apiFetcher.get(`municipality/neighbors`, {
        params: { municipalityId },
      });
      return result;
    });

    return {
      saveMunicipality,
      createMunicipality,
      uploadMunicipalityFile,
      uploadPostalCodesFile,
      uploadPopulationFile,
      getNeighbors,
    };
  });

export type MunicipalityStoreType = Instance<typeof MunicipalityStore>;
